const mobileNavBreakpoint = 1100;

document.querySelectorAll('.site-header').forEach((header, index) => {
    const toggle = header.querySelector('.menu-toggle');
    const menu = header.querySelector('nav ul');

    if (!toggle || !menu) return;

    if (!menu.id) {
        menu.id = `site-nav-menu-${index + 1}`;
    }

    toggle.setAttribute('aria-controls', menu.id);
    toggle.setAttribute('aria-expanded', 'false');

    const closeMenu = () => {
        menu.classList.remove('open');
        toggle.setAttribute('aria-expanded', 'false');
    };

    toggle.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const isOpen = menu.classList.toggle('open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    menu.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => {
            closeMenu();
        });
    });

    document.addEventListener('click', (event) => {
        if (!header.contains(event.target)) {
            closeMenu();
        }
    });

    window.addEventListener('resize', () => {
        if (window.innerWidth > mobileNavBreakpoint) {
            closeMenu();
        }
    });
});

if (window.lucide) {
    window.lucide.createIcons();
}

document.querySelectorAll('.reveal').forEach((el) => {
    const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add('in');
            }
        });
    }, { threshold: 0.15 });
    io.observe(el);
});

const year = document.getElementById('year');
if (year) year.textContent = new Date().getFullYear();

document.querySelectorAll('[data-count]').forEach((el) => {
    const target = Number(el.getAttribute('data-count'));
    if (!Number.isFinite(target)) return;

    let current = 0;
    const step = Math.max(1, Math.floor(target / 30));

    const tick = () => {
        current += step;
        if (current >= target) {
            el.textContent = String(target);
            return;
        }
        el.textContent = String(current);
        requestAnimationFrame(tick);
    };

    tick();
});

document.querySelectorAll('.showroom-gallery-shell').forEach((galleryShell) => {
    const triggers = Array.from(galleryShell.querySelectorAll('.showroom-gallery-trigger'));
    const lightbox = galleryShell.querySelector('.showroom-lightbox');
    const stageImage = lightbox ? lightbox.querySelector('.showroom-lightbox-stage img') : null;
    const count = lightbox ? lightbox.querySelector('.showroom-lightbox-count') : null;
    const closeButton = lightbox ? lightbox.querySelector('.showroom-lightbox-close') : null;
    const backdrop = lightbox ? lightbox.querySelector('.showroom-lightbox-backdrop') : null;
    const prevButton = lightbox ? lightbox.querySelector('.showroom-lightbox-nav.is-prev') : null;
    const nextButton = lightbox ? lightbox.querySelector('.showroom-lightbox-nav.is-next') : null;

    if (!lightbox || !stageImage || !count || !closeButton || !backdrop || !prevButton || !nextButton || !triggers.length) {
        return;
    }

    const slides = triggers
        .map((trigger) => {
            const image = trigger.querySelector('img');
            if (!image) return null;
            return { src: image.getAttribute('src') || '', alt: image.getAttribute('alt') || '' };
        })
        .filter(Boolean);

    if (!slides.length) {
        return;
    }

    let activeIndex = 0;

    const render = () => {
        const current = slides[activeIndex];
        stageImage.setAttribute('src', current.src);
        stageImage.setAttribute('alt', current.alt);
        count.textContent = `${activeIndex + 1} / ${slides.length}`;
    };

    const close = () => {
        lightbox.hidden = true;
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('showroom-lightbox-open');
    };

    const open = (index) => {
        activeIndex = index;
        render();
        lightbox.hidden = false;
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.classList.add('showroom-lightbox-open');
    };

    const move = (step) => {
        activeIndex = (activeIndex + step + slides.length) % slides.length;
        render();
    };

    triggers.forEach((trigger, index) => {
        trigger.addEventListener('click', () => {
            open(index);
        });
    });

    closeButton.addEventListener('click', close);
    backdrop.addEventListener('click', close);
    prevButton.addEventListener('click', () => move(-1));
    nextButton.addEventListener('click', () => move(1));

    document.addEventListener('keydown', (event) => {
        if (lightbox.hidden) return;

        if (event.key === 'Escape') {
            close();
        } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            move(-1);
        } else if (event.key === 'ArrowRight') {
            event.preventDefault();
            move(1);
        }
    });
});

